import {createAction} from 'web-app/util/redux/famly-app-helpers';

const domain = 'CONFIRM_EMAIL';

export const {
    action: confirmEmail,
    success: confirmEmailSuccess,
    failed: confirmEmailFailed,
} = createAction(`${domain}/CONFIRM_EMAIL`, (token: string) => ({token}));
